import AppRulesIndex from "./rule.vue";
import AppRulesList from "./list/list.vue";
import AppRulesItem from "./item/item.vue";

const routes = [
  {
    path: "/rule",
    component: AppRulesIndex,
    meta: {
      auth: {
        roles: "rule.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "rule.index",
        component: AppRulesList,
        meta: {
          auth: {
            roles: "rule.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "rule.create",
        component: AppRulesItem,
        meta: {
          auth: {
            roles: "rule.create",
            redirect: { name: "rule.index" }
          }
        }
      },
      {
        path: ":id",
        name: "rule.edit",
        component: AppRulesItem,
        meta: {
          auth: {
            roles: "rule.update",
            redirect: { name: "rule.index" }
          }
        }
      }
    ]
  }
];

export default routes;
